var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBulkDownloadActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M9.17 10.063c-.002-.02-.003-.042-.003-.063V3.333c0-.46.372-.833.833-.833.461 0 .834.373.834.833V10l2-1.5c.368-.277.89-.202 1.166.167.277.368.202.89-.166 1.166l-3.334 2.5c-.147.111-.324.167-.5.167-.167 0-.335-.05-.479-.152l-3.333-2.345c-.377-.265-.468-.785-.203-1.16.265-.377.784-.468 1.161-.203l2.023 1.423zM5 14.167V15h10v-.833c0-.459.375-.834.834-.834.458 0 .833.375.833.834v1.666c0 .459-.375.834-.834.834H4.168c-.458 0-.833-.375-.833-.834v-1.666c0-.459.374-.834.833-.834.458 0 .833.375.833.834z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBulkDownloadActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bulk_download_active.58e535ed.svg";
export { ForwardRef as ReactComponent };